import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "svg-icon svg-icon-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_6 = {
  class: "modal fade",
  ref: "downloadModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_download_sekolah"
}
const _hoisted_7 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_8 = { class: "modal-content rounded" }
const _hoisted_9 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Download Data Kartu Termapping")
], -1)
const _hoisted_13 = { class: "d-flex flex-column mb-10 fv-row" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          "data-bs-toggle": "modal",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.callModal()))
        }, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
          ]),
          _hoisted_5
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.batalDownload()))
            }, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_form, {
              id: "kt_modal_download_sekolah",
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.targetData,
              ref: "formRef",
              class: "form"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_Multiselect, {
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pilihSchoolStatus($event))),
                        modelValue: _ctx.items.schoolStatus,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.items.schoolStatus) = $event)),
                        placeholder: "Pilih Status",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.items.comboSchoolStatus,
                        searchable: true,
                        label: "name",
                        "track-by": "name",
                        "value-prop": "_id"
                      }, null, 8, ["modelValue", "options"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger me-3",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batalDownload()))
                  }, " Batal "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadtermapping()))
                  }, " Download ")
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}